import {useState} from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuthContext } from '../../../hooks/useAuthContext.js'
import LoginTile from '../../Components/LoginTile/LoginTile.js';

const Register = () => {
    const {signUp} = useAuthContext()
    const [data , setData] = useState(null)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false);
    const {dispatch} = useAuthContext()
    
    const [searchParams, setSearchParams] = useSearchParams();
    const tier = searchParams.get('tier')

    const handleSubmit = async (event, email, password) => {
        event.preventDefault()
        setLoading(true)

        const userData = await signUp(
            email,
            password
        )
       
        if(userData.error){
            setError(userData.error)
        } else {
            setLoading(true)
            setData(userData.data)
            console.log("Stripe Payment Initiated");
            window.location.href = "/CheckoutPage?tier=" + tier;
           // dispatch({type: 'SIGNUP_SUCCESS', payload:userData}) 
        }
           
        setLoading(false);
    } 

    
  
    return (
        <LoginTile
            type='register'
            handleSubmit={handleSubmit}
        />
    )
}



export default Register;